var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterest(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 14.55c-.63 3.03-1.4 5.933-3.68 7.45-.704-4.578 1.033-8.016 1.84-11.666-1.376-2.122.165-6.393 3.066-5.341 3.57 1.294-3.09 7.89 1.38 8.715 4.669.86 6.575-7.426 3.68-10.12C10.705-.303 2.712 3.498 3.694 9.07c.24 1.361 1.774 1.774.614 3.654C1.63 12.179.83 10.244.934 7.664 1.099 3.44 5.074.484 9.06.074c5.041-.517 9.773 1.696 10.426 6.044.736 4.907-2.275 10.221-7.666 9.839-1.462-.105-2.075-.769-3.22-1.406z"
  })));
}
export default SvgPinterest;